
import { ImportData } from "components/hr-metrics/employee-productivity/create/ImportData";
import { DEFAULT_FORM_EMPLOYEE_PRODUCTIVITY, INITIAL_DATA_QUERY_EMPLOYEE_PRODUCTIVITY_DETAIL } from "configs/hr-metrics/configTableEmployeeProductivityList";
import { ACTION_TYPE } from "constants/constant";
import { useValidation } from "hooks/useValidation";
import { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { API_EMPLOYEE_PRODUCTIVITY } from "services/apiEmployeeProductivity";
import { useFetch } from "services/useFetch";
import { getAllQueryParams, setQueryParams } from "utils/utils";

const FILTER_PARAMS = ['departments', 'divisions']

export const ImportDataContainer = () => {
    const location = useLocation()
    const navigate = useNavigate()
    const [searchParams, setSearchParams] = useSearchParams()
    const periodId = searchParams.get('periodId')
    const [queryFilter, setQueryFilter] = useState()
    const query = searchParams.size > 0 ? getAllQueryParams(searchParams) : INITIAL_DATA_QUERY_EMPLOYEE_PRODUCTIVITY_DETAIL
    const [form, setForm] = useState(DEFAULT_FORM_EMPLOYEE_PRODUCTIVITY)
    const [isShowToast, setIsShowToast] = useState(false)
    const [toastMessage, setToastMessage] = useState('')
    const [modal, setModal] = useState({
        import: false,
        delete: false,
        edit: false,
        limit: false
    })

    const { data: dataListJobTitle, fetching: getJobTitleList } = useFetch(API_EMPLOYEE_PRODUCTIVITY.LIST_JOB_TITLE, {limit: 5}, { isFetching: true })
    const {data: detailList, fetching: getDetail, isLoading} = useFetch({...API_EMPLOYEE_PRODUCTIVITY.DETAIL, initPathVariable: periodId}, INITIAL_DATA_QUERY_EMPLOYEE_PRODUCTIVITY_DETAIL)    
    const {fetching: updateEmployeeProductivity, isLoading: isUpdating} = useFetch(API_EMPLOYEE_PRODUCTIVITY.UPDATE)
    const {fetching: deleteEmployeeProductivity, isLoading: isDeleting} = useFetch(API_EMPLOYEE_PRODUCTIVITY.DELETE)
    const {fetching: postEmployeeProductivity, isLoading: isLoadingSubmit} = useFetch(API_EMPLOYEE_PRODUCTIVITY.SUBMIT)
    const { isFormValid } = useValidation({ form: form })


    const optionsJobTitle = useMemo(() => {
        const mapOptions = (dataList) => {
            if (!dataList || dataList?.length === 0) return []
            return dataList?.map((item) => ({
                label: item.name,
                value: item,
            }))
        }

        const optionsJobTitle = mapOptions(dataListJobTitle?.data)
        return optionsJobTitle
    }, [dataListJobTitle?.data])
    
    useEffect(() => {
        getDetailList()
    }, [location?.search])

    const getDetailList = async () => {
        const newQuery = {...query}
        const newQueryFilter = {}
        Object.entries(newQuery).forEach(([key, item]) => {
            if (FILTER_PARAMS.includes(key)) {
                const valueOfQuery = FILTER_PARAMS.slice(0, 4).includes(key) ? item.split(',') : item
                newQuery[key] = valueOfQuery
                newQueryFilter[key] = valueOfQuery
            }
        })
        setQueryFilter(newQueryFilter)
        getDetail(newQuery)
    }

    const onChangeQuery = (queryParams) => {
        const params = setQueryParams({...query, ...queryParams})
        setSearchParams(params, {replace: true})
    }

    const setShowModal = (value) => {
        setModal({...modal, ...value})
    }

    const clearToast = () => {
        setIsShowToast(false)
        setToastMessage('')
    }

    const showToast = (message) => {
        setIsShowToast(true)
        setToastMessage(message)
    }

    const onChangeForm = (e) => {
        const { name, value } = e
        if (name === 'job_title_id') {
            setForm({ ...form, 
                job_title_id: value,
                department: value?.value?.department || '-',
                division: value?.value?.division || '-'
            })
            return
        }
        setForm({ ...form, [name]: value })
    }

    const onSearchOptions = ({ key, keyword }) => {
        if (key === 'job_title_id') {
            return getJobTitleList({ search: keyword })
        }
    }

    const onHideImport = (refresh) => {
        setModal({...modal, import: false})
        if (refresh) getDetailList()
    }

    const onClickItemHandler = ({item, actionType}) => {
        setForm({
            id: item?.id,
            employee_name: item?.employee_name,
            employee_nip: item?.employee_nip,
            kpi_value: item?.kpi_value,
            salary_value: item?.salary_value,
            job_title_id: {
                label: item?.job_title?.name,
                value: item?.job_title?.id
            },
            department: item?.department?.name || '-',
            division: item?.division?.name || '-'
        })
        switch (actionType) {
            case ACTION_TYPE.EDIT:
                setShowModal({edit: true})
                break
            case ACTION_TYPE.DELETE:
                setShowModal({delete: true})
                break
            default:
                break
        }
    }

    const onDelete = () => {
        deleteEmployeeProductivity(null, form?.id)
            .then(() => {
                setModal({...modal, delete: false})
                showToast('Employee Productivity Deleted !!')
                getDetailList()
            })
    }

    const onSubmitEdit = () => {
        const payload = {
            kpi_value: form?.kpi_value,
            salary_value: form?.salary_value,
            job_title_id: form?.job_title_id?.value?.id || form?.job_title_id?.value,
        }
        updateEmployeeProductivity(payload, form?.id)
            .then(() => {
                setModal({...modal, edit: false})
                showToast('Employee Productivity Updated !!')
                getDetailList()
            })
    }

    const onSubmit = () => {
        postEmployeeProductivity(null, periodId)
            .then(() => {
                showToast('Employee Productivity Submitted !!')
                navigate(`/human-resource-metrics/employee-productivity/detail-employee-productivity?periodId=${periodId}`)
            }).catch(error => {
                if (error?.code === "400-AB004") {
                    navigate(`/human-resource-metrics/employee-productivity/detail-employee-productivity?periodId=${periodId}`)
                }
            }) 
    }

    const saveAsDraf = () => {
        navigate(`/human-resource-metrics/employee-productivity`)
    }

    const props = {
        dataList: detailList?.data,
        isLoading,
        isDeleting,
        isUpdating,
        isLoadingSubmit,
        query,
        queryFilter,
        toast: {
            isShowToast,
            message: toastMessage
        },
        modal,
        optionsJobTitle,
        form,
        isFormValid: isFormValid(),
        onChangeQuery,
        setShowModal,
        clearToast,
        onChangeForm,
        onSearchOptions,
        onHideImport,
        onClickItemHandler,
        onDelete,
        onSubmitEdit,
        onSubmit,
        saveAsDraf,
    }

    return (
        <ImportData {...props}/>
    )
}
